import { Component, OnDestroy, OnInit } from '@angular/core';
import { SiteService } from '@app/app-state/site.service';
import { UserService } from '@app/app-state/user.service';
import { ChartDataService } from '@app/backend/chart-data.service';
import { GenerateChartDataService } from '@app/backend/generate-chart-data.service';
import { ChartDataInterface, DrillDetailsInterface } from "@app/models/chart-data.model";
import * as Highcharts from 'highcharts/highstock';
import * as charts from '@utilities/highchart-objectify';
import { Subscription } from 'rxjs';
import { GraphReportComponent } from '@app/gui/report/graph-report/graph-report.component';
import { MatDialog } from '@angular/material/dialog';
import { ChartHelperService } from '@app/backend/chart-helper.service';

@Component({
	selector: 'app-pf-and-tons',
	templateUrl: './pf-and-tons.component.html',
	styleUrls: ['./pf-and-tons.component.scss']
})
export class PfAndTonsComponent implements OnInit, OnDestroy {

	public Highcharts: typeof Highcharts = Highcharts; // required

	public chartOptions = [] // required
	private subscriptions: Subscription = new Subscription();

	public loading:boolean;

	private domainId: number;
	private subdomainId: number;
	private siteId: number;
	private startDate: string;
	private endDate: string;
	private selectedTimeline: string
	public visibleDownloadMenuIndex: number | null = null;
	private pfAndTons:ChartDataInterface[] = [];

	constructor(
		private chartDataService:ChartDataService,
		private generateChartDataService:GenerateChartDataService,
		private siteService: SiteService,
		private userService: UserService,
		private dialog: MatDialog,	
		private chartHelper: ChartHelperService,
	) {}

	ngOnInit(): void {
		
		this.subscriptions.add(this.chartDataService.loading$.subscribe(loading => {
			this.loading = loading;
		}));

		this.subscriptions.add(this.chartDataService.drillDetails$.subscribe((res) => {
			this.triggerLoadData(res);
		}));
		
		this.subscriptions.add(this.siteService.domainId$.subscribe(domainId => {
			this.domainId = domainId;
			if (this.domainId) {
				this.getData();
			}
		}));

		this.subscriptions.add(this.siteService.subDomainId$.subscribe(subdomainId => {
			this.subdomainId = subdomainId;
			this.triggerLoadData();
		}));

		this.subscriptions.add(this.siteService.siteId$.subscribe(siteId => {
			this.siteId = siteId;
			this.triggerLoadData();
		}));

		this.subscriptions.add(this.siteService.startDate$.subscribe(startDate => {
			this.startDate = startDate;
			this.triggerLoadData();
		}));

		this.subscriptions.add(this.userService.userUnitMeasurement$.subscribe(() => {
			this.triggerLoadData();
		}));

		this.subscriptions.add(this.siteService.selectedTimeline$.subscribe(selectedTimeline => {
			this.selectedTimeline = selectedTimeline;
			this.triggerLoadData();
		})); 

		this.subscriptions.add(this.siteService.endDate$.subscribe(endDate => {
			this.endDate = endDate;
			this.triggerLoadData();
		}));
	}

	private getData(){
		this.subscriptions.add(this.chartDataService.getCacheDrillDetails().subscribe(details => {
			this.triggerLoadData(details);
		}))
	}

	private loadData = (chartData: ChartDataInterface[])=> {
		this.pfAndTons = chartData;
		const data: DrillDetailsInterface = this.generateChartDataService.generateChartData(this.pfAndTons, true);
		for (const key in data?.pfAndTonData) {
			this.chartOptions = charts.generateChartOptions(data.pfAndTonData[key]);
			this.chartDataService.exportedGraphData$.next(data.pfAndTonData[key]);
		}
	}

	private triggerLoadData(data? : ChartDataInterface[]) {
		const originalDrillAndBalstData = data || this.generateChartDataService.originalDrillAndBalstData;
		this.pfAndTons = this.generateChartDataService.getFilteredData(
			originalDrillAndBalstData,
			this.domainId,
			this.subdomainId,
			this.siteId,
			this.startDate,
			this.endDate,
			this.selectedTimeline    
		);
		this.loadData(this.pfAndTons);
	}

	public pdfDownload() {
		this.dialog.open(GraphReportComponent, {
			width: '100vw', 
			height: '100vh',
			maxWidth: '100vw',
			panelClass: 'full-screen-dialog',
			disableClose: true
		});
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	chartRefs: Highcharts.Chart[] = [];
		
	onChartInstance(chart: Highcharts.Chart, index: number): void {
		this.chartRefs[index] = chart;
	}
}